import api from './api';
import {
  Employee,
  CreateEmployeeData,
  UpdateEmployeeData,
  ApiResponse,
  PaginatedResponse,
} from '../types';

export const employeeService = {
  async getBirthdaysToday(): Promise<{ id: number; firstName: string; lastName: string; employeeCode: string }[]> {
    const response = await api.get<ApiResponse<{ id: number; firstName: string; lastName: string; employeeCode: string }[]>>(
      '/employees/birthdays/today'
    );
    return response.data.data || [];
  },

  /** Minimal list of active employees for dropdowns (e.g. Reimbursement "Paid By"). Any authenticated user. */
  async getActiveList(): Promise<{ id: number; firstName: string; lastName: string; employeeCode: string }[]> {
    const response = await api.get<ApiResponse<{ id: number; firstName: string; lastName: string; employeeCode: string }[]>>(
      '/employees/managers/list'
    );
    return response.data.data || [];
  },

  async getAll(
    page: number = 1,
    limit: number = 10,
    filters?: { department?: string; isActive?: boolean }
  ): Promise<PaginatedResponse<Employee>> {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      ...(filters?.department && { department: filters.department }),
      ...(filters?.isActive !== undefined && { isActive: String(filters.isActive) }),
    });
    const response = await api.get<ApiResponse<Employee[]> & { pagination: PaginatedResponse<Employee>['pagination'] }>(
      `/employees?${params}`
    );
    return {
      data: response.data.data!,
      pagination: response.data.pagination,
    };
  },

  async getById(id: number): Promise<Employee> {
    const response = await api.get<ApiResponse<Employee>>(`/employees/${id}`);
    return response.data.data!;
  },

  async getMyProfile(): Promise<Employee> {
    const response = await api.get<ApiResponse<Employee>>('/employees/me');
    return response.data.data!;
  },

  async create(data: CreateEmployeeData): Promise<Employee> {
    const response = await api.post<ApiResponse<Employee>>('/employees', data);
    return response.data.data!;
  },

  async update(id: number, data: UpdateEmployeeData): Promise<Employee> {
    const response = await api.put<ApiResponse<Employee>>(`/employees/${id}`, data);
    return response.data.data!;
  },

  async updateMyProfile(data: UpdateEmployeeData): Promise<Employee> {
    const response = await api.put<ApiResponse<Employee>>('/employees/me', data);
    return response.data.data!;
  },

  async uploadProfilePhoto(file: File): Promise<void> {
    const formData = new FormData();
    formData.append('photo', file);
    await api.post('/documents/me/photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  async deactivate(id: number): Promise<void> {
    await api.delete(`/employees/${id}`);
  },

  async reactivate(id: number): Promise<void> {
    await api.post(`/employees/${id}/reactivate`);
  },
};
